import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { createContext } from "react"
import { useLocation } from "react-router-dom"

import { retry } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

import HeaderContent from "./header-content"

const MobileMenu = loadable(
  () => retry(() => import("./menu/mobile/main-menu")),
  { ssr: false }
)

export const HeaderMenuContext = createContext()

const Header = ({ menu }) => {
  const location = useLocation()
  const isTablet = useWindowDimensions().isTablet

  if (
    location.pathname.includes("/checkout") ||
    location.pathname.includes("/payments") ||
    location.pathname.includes("/order")
  ) {
    return ""
  }

  return (
    <HeaderMenuContext.Provider value={{ menu }}>
      <HeaderContent />
      {isTablet && <MobileMenu />}
    </HeaderMenuContext.Provider>
  )
}

Header.propTypes = {
  menu: PropTypes.object,
}

export default Header
